/**
 * Fetches and shows the result of the TasteProfileOnboarding questionnaire, initially showing a
 * loading screen
 */

import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { createStructuredSelector } from 'reselect'
import { push } from 'react-router-redux'

import Button from 'components/Button'
import PersonalTasteProfile from '../PersonalTasteProfile'
import ResultLoading from '../../components/ResultLoading'
import Cta from '../../components/Cta'
import Notification from 'components/Notification'
import {
  selectFetchResultFailed, selectHasAnsweredAllQuestions, selectHasResult
} from './selectors'
import { fetchResults } from '../PersonalTasteProfile/actions'
import { selectResult } from '../PersonalTasteProfile/selectors'
import Header from 'environments/TasteProfileOnboarding/components/Header'
import USPBlock from 'environments/TasteProfileOnboarding/components/USPBlock'
import { trackTasteProfileEvent } from 'utils/tagManager'

import { RED_LABEL_NL, WHITE_LABEL_NL } from 'constants/wines'
import styles from './result.css'

export class Result extends Component {
  constructor (props) {
    super(props)

    this.state = {
      animationMinTimeCompleted: false,
      allAnimationsComplete: false
    }

    this.handleAnimationComplete = this.handleAnimationComplete.bind(this)
    this.markAnimationMinTimeComplete = this.markAnimationMinTimeComplete.bind(this)

    this.test200IsActive = !!document.querySelector('body[data-test-200]')
  }

  componentWillMount () {
    if (!this.props.hasResult) {
      if (this.props.hasAnsweredAllQuestions) {
        this.props.requestResults()
      } else {
        this.props.navigateTo(process.env.WEBSHOP_SMAAKPROFIELEN_PATH + '/doe-de-test/')
      }
    }
  }

  componentDidMount () {
    this.minTimeTimeout = setTimeout(this.markAnimationMinTimeComplete, this.props.animationMinTime)
  }

  componentWillUnmount () {
    clearTimeout(this.minTimeTimeout)
  }

  render () {
    const {fetchResultFailed, result, animationMinTime, hasResult} = this.props
    const {animationMinTimeCompleted, allAnimationsComplete} = this.state

    const errorMessage = `
      Er is iets fout gegaan. Als deze fout zich herhaaldelijk voordoet,
      neem dan contact op met onze klantenservice 075-6594200.`

    if (fetchResultFailed) {
      return (
        <div className={styles.wrapper}>
          <Notification style={{variant: 'error'}} message={errorMessage} />
          <ResultLoading />
        </div>
      )
    }
    const renderLoading = (!hasResult && !animationMinTimeCompleted) || !allAnimationsComplete
    return (renderLoading ? (
      <ResultLoading
        result={result}
        animationMinTime={animationMinTime}
        animationMinTimeCompleted={animationMinTimeCompleted}
        onAnimationComplete={this.handleAnimationComplete}
      />
    ) : (
      <div className={styles.wrapper}>

        <h2 className={styles.h2}>
            Smaakprofielen
        </h2>

        <PersonalTasteProfile />

        {this.test200IsActive
          ? <Cta requestResults={this.props.requestResults} />
          : null}

        <div className={styles.content}>
          <Header className={styles.separatingHeader}>
              Wat kun je allemaal met smaakprofielen?
          </Header>

          <div className={styles.uspBlocks}>
            <USPBlock title="In de winkel">
                Bij elke wijn is aangegeven welk smaakprofiel het is. Zo herken
                je
                makkelijk de wijnen die horen bij jouw persoonlijke
                smaakprofielen.
            </USPBlock>
            <USPBlock title="Online">
                Log in, of registreer. In je account vind je dan jouw
                persoonlijke
                wijnlijst. Het leuke is dat je ook kan zien hoe goed de
                verschillende wijnen met jouw persoonlijke profiel matchen.
            </USPBlock>
            <USPBlock title="Op een feestje">
                Gaat het over wijn, dan hoef jij het gesprek niet meer te
                ontwijken. Jij bent een ware kenner, en legt haarfijn uit dat je
                bijvoorbeeld een voorkeur voor intensiteit en een lage zuurgraad
                hebt.
            </USPBlock>
            <USPBlock title="In het restaurant">
                Jij weet de sommelier haarfijn uit te leggen wat jij wel en niet
                kunt waarderen aan wijnen. Samen komen jullie tot een wijn die je
                avond perfect maakt.
            </USPBlock>
          </div>

          <div className={styles.buttonWrapper}>
            <Button
              href={process.env.WEBSHOP_SMAAKPROFIELEN_PATH + '/doe-de-test/'}
              className={styles.ctaButton}
              size={'small'}
              {...trackTasteProfileEvent('Doe de test opnieuw')}
            >
                Doe de test opnieuw
            </Button>
            <Button
              href="/smaakprofielen/alle-smaakprofielen/"
              className={styles.ctaButton}
              size={'small'}
            >
                Bekijk alle smaakprofielen
            </Button>
          </div>
        </div>
      </div>
    )
    )
  }

  handleAnimationComplete () {
    this.setState(() => ({
      allAnimationsComplete: true
    }))
  }

  markAnimationMinTimeComplete () {
    this.setState(() => ({
      animationMinTimeCompleted: true
    }))
  }
}

Result.propTypes = {
  hasResult: PropTypes.bool.isRequired,
  requestResults: PropTypes.func.isRequired,
  fetchResultFailed: PropTypes.bool,
  hasAnsweredAllQuestions: PropTypes.bool,
  navigateTo: PropTypes.func.isRequired,
  animationMinTime: PropTypes.number,
  result: PropTypes.shape({
    [RED_LABEL_NL]: PropTypes.shape(),
    [WHITE_LABEL_NL]: PropTypes.shape()
  })
}

Result.defaultProps = {
  fetchResultFailed: undefined,
  hasAnsweredAllQuestions: undefined,
  animationMinTime: 5000,
  result: null
}

const mapStateToProps = createStructuredSelector({
  hasResult: selectHasResult,
  result: selectResult,
  fetchResultFailed: selectFetchResultFailed,
  hasAnsweredAllQuestions: selectHasAnsweredAllQuestions
})

function mapDispatchToProps (dispatch) {
  return {
    requestResults: () => dispatch(fetchResults(2000)),
    navigateTo: (path) => dispatch(push(path))
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(Result)
